import { useSiteParameter } from '@common/composables/site-parameters';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

export const availableFeatures = {
  SOURCES : 'sources',
  DESTINATIONS :'destinations',
  TAGS:'tags',
  ENRICHMENTS:'enrichments',
  WEB_CONTAINERS:'web_containers',
  STORAGE_SETTINGS:'storage_settings',
  CLEANSING_TRANSFORMATIONS:'cleansing_transformations',
  EVENT_SPECIFICATIONS:'event_specifications'
};

const featureNameToI18n = {
  sources: 'featureLocked.sources',
  destinations: 'featureLocked.destinations',
  tags: 'featureLocked.tags',
  enrichments: 'featureLocked.enrichments',
  web_containers: 'featureLocked.web_containers',
  storage_settings: 'featureLocked.storage_settings',
  cleansing_transformations: 'featureLocked.cleansing_transformations',
  event_specifications: 'featureLocked.event_specifications'
};

export const useEmergencyFeatureLock = (featureName) => {
  const { t } = useI18n({ useScope: 'global' });

  if (!Object.values(availableFeatures).includes(featureName)) {
    throw new Error(`Feature ${featureName} is not available`);
  }

  const emergencyFeatures = useSiteParameter('disabled_features');
  
  const isFeatureLocked = computed(() => {
    if(Array.isArray(emergencyFeatures.value)){
      return emergencyFeatures.value.includes(featureName);
    }
    return false;
  });

  return {
    isFeatureLocked,
    hoverTooltip: t('featureLocked.hover', [t(featureNameToI18n[featureName]).toLowerCase()]),
  };
};
